import {login, first_login, forgot} from '../../../api/auth/email'
import {USER_LOGIN,USER_ERROR} from './index'
import { history } from 'store'
import { PROTOCOL_RESET } from '../protocol'
export function userLogin(email, password, xThis) {
    return dispatch => {
        login(email, password).then(response => {
            const {id,token, role, department,photo,theme,language} = response.data
            localStorage.removeItem('protocols')
            localStorage.removeItem('filter')
            localStorage.setItem('token', token)
            dispatch({
                type: USER_LOGIN,
                token,
                role: Number(role),
                photo,
                language,
                theme,
                id,
                isLogged: true,
                department
            })
            dispatch({ type: PROTOCOL_RESET })
            history.push(Number(role) === 3 ?  '/workflow' : (Number(role) === 6 ? '/' : '/chats/humano/atendimento'))
        }).catch(error => {
            const status = error?.response?.status
            if (status === 400 || status === 401) {
                if (error?.response?.data?.first_login) {
                    xThis.dialogChangePass.handleClickOpen()
                }else if(error?.response?.data.warning){
                    dispatch({
                        type: USER_ERROR,
                        email: error?.response?.data?.warning,
                        ...error.response.data
                    })
                } else {
                    dispatch({
                        type: USER_ERROR,
                        ...error?.response?.data
                    })
                }
            } else {
                dispatch({
                    type: USER_ERROR,
                    email: 'Erro na api contate o suporte'
                })
            }
        })
    }
}

export function firstLogin(email, password, newPassword, confirmPassword) {

    return dispatch => {

        first_login(email, password, newPassword, confirmPassword).then(response => {
            const {id,token,department,role,photo,theme,language} = response.data

            if (token) {
                localStorage.removeItem('token')
                localStorage.setItem('token', token)
                dispatch({
                    type: USER_LOGIN,
                    id,
                    token,
                    theme,
                    role: Number(role),
                    photo,
                    language,
                    department
                })
                history.push(Number(role) === 3 ?  '/workflow' : (Number(role) === 6 ? '/' : '/chats/humano/atendimento'))
            }
        }).catch(error => {
            dispatch({
                type: USER_ERROR,
                ...error.response.data
            })
        })
    }
}

export function forgotPassword(email, xThis) {
    return dispatch => {
        forgot(email).then(response => {
            const {enqueueSnackbar} = xThis.props
            enqueueSnackbar(response.data.message, {key: 'forgot', variant: 'success'})
            xThis.dialogForgot.handleClickOpen()
        }).catch(error => {
            const status = error.response.status
            const {email} =  error.response.data
            const {warning} =  error.response.data

            if (status === 400 || status === 401)
                dispatch({
                    type: USER_ERROR,
                    email_forgot: email ?? warning
                })
        })
    }
}